import { Text } from '@backend/lib-design-system';
import type { PropsWithChildren } from 'react';
import { styled } from 'styled-components';

export const StyledFooterLegalMenuItem = styled.div`
  cursor: pointer;
`;

type FooterLegalMenuItemProps = {
  className?: string;
  href?: string;
  onClick?: () => void;
};

export const FooterMenuItem = ({ className, href, children, onClick }: PropsWithChildren<FooterLegalMenuItemProps>) => (
  <StyledFooterLegalMenuItem className={className}>
    {href ? (
      <a href={href}>
        <Text variant="body-lighter">{children}</Text>
      </a>
    ) : (
      <Text variant="body-lighter" onClick={onClick}>
        {children}
      </Text>
    )}
  </StyledFooterLegalMenuItem>
);
